module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5020/images/default-avatar.png"